// extracted by mini-css-extract-plugin
export default {"root":"h31_xXmOA6","root_active":"VZ62sUmn0B","actions":"sETndPlmxW","icon":"MoD89NThYj","icon_appColor":"hxeQUHs3aO","name":"c8WqIWAelA","actions_isOpen":"_2zQjz1B75N"};